<template>
  <b-overlay :show="isLoading" rounded="lg">
    <b-card title="Sumitomo - Return Delivery List">
      <b-modal v-model="modalFTP" title="Send Return FTP">
        <b-container>
          <b-row>
            <b-col cols="12">
              <div class="d-flex">
                Send Return PDF of DO {{this.ftpData.sapDo}} to FTP ?
              </div>
            </b-col>
          </b-row>
        </b-container>
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-center align-items-center">
            <b-button variant="success" class="ml-1" @click="sendFTP" :disabled="tableLoading"
              >Confirm
            </b-button>
          </div>
        </template>
      </b-modal>
      <b-col cols="12">
        <!--only show for mobile view, THIS IS SECOND PAGE MENU TO SHOW SORT DATA OPTIONS *if needed same with other mobile view-->
        <b-row class="hide-on-desktop" v-if="btnshow">
          <!-- <b-col md="6" style="margin-bottom:10px; margin-top:10px">
            <b-form-group
              label="Sort By"
              label-for="sort-by-select"
              label-cols-md="0"
              label-align-sm="left"
              label-size="md"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-select
                  id="sort-by-select"
                  v-model="sortBy"
                  :options="sortOptions"
                  class="w-75"
                >
                  <template #first>
                    <option value="">-- none --</option>
                  </template>
                </b-form-select>

                <b-form-select
                  v-model="sortDesc"
                  :disabled="!sortBy"
                  :options="directionOptions"
                  size="sm"
                  class="w-25"
                >
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col> -->
          <b-col cols="12">
            <b-row>
              <b-button
                size="lg"
                class="w-100 d-flex justify-content-center align-items-center"
                style="margin-bottom:15px;"
                variant="primary"
                @click="btnForMobile('All')"
              >
                All
              </b-button>
            </b-row>
            <b-row>
              <b-button
                size="lg"
                class="w-100 d-flex justify-content-center align-items-center"
                style="margin-bottom:15px;"
                variant="primary"
                @click="btnForMobile('Returned')"
              >
                Returned
              </b-button>
            </b-row>
            <b-row>
              <b-button
                size="lg"
                class="w-100 d-flex justify-content-center align-items-center"
                style="margin-bottom:15px;"
                variant="primary"
                @click="btnForMobile('Waiting Acknowledgment')"
              >
                Waiting Acknowledgment
              </b-button>
            </b-row>
            <b-row>
              <b-button
                size="lg"
                class="w-100 d-flex justify-content-center align-items-center"
                style="margin-bottom:15px;"
                variant="primary"
                @click="btnForMobile('Waiting Approval')"
              >
                Waiting Approval
              </b-button>
            </b-row>
            <b-row>
              <b-button
                size="lg"
                class="w-100 d-flex justify-content-center align-items-center"
                style="margin-bottom:15px;"
                variant="primary"
                @click="btnForMobile('Approved')"
              >
                Approved
              </b-button>
            </b-row>
            <b-row>
              <b-button
                size="lg"
                class="w-100 d-flex justify-content-center align-items-center"
                style="margin-bottom:15px;"
                variant="primary"
                @click="btnForMobile('Return Completed')"
              >
                Return Completed
              </b-button>
            </b-row>
          </b-col>
        </b-row>
        <!--END only show for mobile view-->
        <b-row :class="btnBackMobile">
          <b-button size="md" @click="actBackMobile" variant="primary">
            Back
          </b-button>
        </b-row>
        <!--this is options for search data, only "Filter by Status" will dissapear on mobile view-->
        <b-row>
          <b-col md="6" class="ml-md-auto hide-on-mobile">
            <strong>Filter by Status :</strong>
            <b-form-select
              @input="(value) => statusFiltering(value)"
              id="delivery-status"
              v-model="deliveryStatus"
              :options="listStatus"
              @click="filterDelivery"
            >
            </b-form-select>
          </b-col>
          <b-col md="6" :class="conditionView">
            <b-form-input
              
              v-model="search"
              type="search"
              placeholder="Search by DO"
              style="float: right; margin-top: 20px; margin-bottom: 30px;"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" :class="conditionView">
            <b-form-input
              v-model="searchSO"
              type="search"
              placeholder="Search by SO"
              style="float: right; margin-bottom: 30px;"
            />
          </b-col>
          <b-col md="6" :class="conditionView">
            <b-row>
              <b-col md="10" cols="9">
                <b-form-datepicker
                  @input="(value) => fireFiltering(value)"
                  placeholder="Search by Delivery Date"
                  v-model="delivDate"
                  style="float: right;  margin-bottom: 30px;"
                />
              </b-col>
              <b-col md="2" cols="3">
                <b-button variant="danger" @click="cleanQuery">X</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-col :class="conditionView" class="mb-1">
          <b-button @click="doFiltering" variant="primary" style="margin-right: 10px;">search</b-button>
          <span style="color: red;"></span>
        </b-col>
        <!--END this is options for search data-->
        <b-row :class="conditionView">
          <b-col cols="12">
            <b-table
              class="custom-row-height"
              responsive
              small
              hover
              bordered
              show-empty
              :items="filterDelivery"
              :fields="fields"
              :busy.sync="tableLoading"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :stacked="stackedStatus"
              ref="delivery"
            >
              <template #cell(index)="row">
                {{ row.index + 1 + (currentPage - 1) * 10 }}
              </template>

              <template v-slot:cell(deliveryDate)="row">
                {{ dates(row.item.deliveryDate) }}
              </template>
              <template v-slot:cell(ftp)="row">
                {{ (row.item.ftpReturnSent)?"Sent":"Not Sent" }}
                <b-button
                  v-if="!row.item.ftpReturnSent && row.item.status=='Return Completed'"
                    size="sm"
                    variant="primary"
                    @click="toFTP(row.item)"
                    class="mr-1"
                  >
                  Send FTP
                </b-button>
              </template>
              <template #cell(actions)="row">
                <b-dropdown
                  id="dropdown-dropleft"
                  :dropleft="showDropdown"
                  variant="primary"
                  size="sm"
                  text="Menu"
                  no-caret
                >
                  <template #button-content>
                    <feather-icon size="1x" icon="MenuIcon" />
                  </template>
                  <b-dropdown-item
                    style="text-align:center"
                    v-if="checkDetail(row.item)"
                  >
                    <b-button
                      size="sm"
                      variant="info"
                      @click="toDetailPage(row.item)"
                      class="mr-1"
                    >
                      <feather-icon icon="EyeIcon" />
                    </b-button>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="row.item.status === 'Returned' && permission.view"
                  >
                    <b-button
                      size="sm"
                      variant="primary"
                      @click="toReturn(row.item)"
                      class="mr-1"
                    >
                      Create Return e-Form
                    </b-button>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="row.item.status === 'Approved' && permission.unpick"
                  >
                    <b-button
                      size="sm"
                      variant="primary"
                      @click="toUnpickScan(row.item)"
                      class="mr-1"
                    >
                      Unpick and Scan
                    </b-button>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row :class="conditionView" style="margin-top:10px">
          <b-col md="9" />
          <b-col md="3">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              @change="onPageChange"
              v-model="currentPage"
              align="fill"
              class="hide-on-desktop"
            />
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              @change="onPageChange"
              v-model="currentPage"
              class="hide-on-mobile"
              style="float: right"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapActions } from "vuex";
import axios from "@/axios";
import { userAccess, dateFormat } from "@/utils/utils";
export default {
  data() {
    let mobileViewQuery = window.matchMedia("(max-width: 761px)"); //check true or false width screen mobile view
    return {
      mobileViewQuery: mobileViewQuery, //all info matchMedia
      mobileView: mobileViewQuery.matches, // return true or false match screen moobile view
      //FIELD FOR MOBILE
      btnshow: true,
      showDropdown: true,
      btnBackMobile: "hide-at-all",
      conditionView: "ml-md-auto hide-on-mobile",
      stackedStatus: "md",
      //sort direction list for mobile view
      directions: [
        { key: false, label: "Asc", sortable: true },
        { key: true, label: "Desc", sortable: true },
      ],
      //END FIELD FOR MOBILE
      fields: [
        { key: "index", label: "No" },
        { key: "sapSo", label: "SAP SO" },
        { key: "sapDo", label: "SAP DO" },
        { key: "deliveryDate", label: "Delivery Date" },
        { key: "ongoingReturnedQty", label: "Ongoing Return Qty" },
        { key: "returnedQty", label: "Returned Qty" },
        { key: "status", label: "STATUS" },
        { key: "ftp", label:"FTP"},
        { key: "actions", label: "Actions" },
      ],
      shippingPoint : "1003",
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      tableLoading: true,
      isLoading: false,
      sortBy: "", //this for mobile view if needed same with other mobile view
      sortDesc: false, //this for mobile view if needed same with other mobile view
      showSortBy: false, //this for mobile view if needed same with other mobile view
      search: "",
      searchSO:"",
      selectData: "",
      listStatus: [
        "All",
        "Returned",
        "Waiting Acknowledgment",
        "Waiting Approval",
        "Approved",
        "Return Completed",
      ],
      defaultStatus:"Returned",
      deliveryStatus: "",

      delivDate: "", //model for search data by delivery date
      modalFTP:false,
      ftpData:{
        sapDo:"",
        id:"",
        isManualReturn:false
      }
    };
  },
  computed: {
    filterDelivery() {
      var result = this.deliveryOrders;
      if (this.deliveryStatus == "All") {
        // let wantedStatus = [
        //   "Returned",
        //   "Waiting Acknowledgment",
        //   "Waiting Approval",
        //   "Approved",
        //   "Return Completed",
        // ];
        // result = result.filter((x) => {
        //   if (x.status === undefined) {
        //     return false;
        //   }
        //   return x.status.includes(wantedStatus);
        // });

        console.log("ALL RESULT", result);
      } else {
        console.log("ELSE");
        result = result.filter((x) => x.status === this.deliveryStatus);
      }
      result = result.map(order => {
        let ongoingReturnedQty = 0;
        let returnedQty = 0;

        
          order.DO_details.forEach(detail => {
            if(detail.skip){
              var qtyTemp = (detail.qtyUpdate)?detail.qtyUpdate:detail.qty;
              ongoingReturnedQty += (detail.returnBarcode.length + detail.scannedBarcode.length - qtyTemp);
              returnedQty += (qtyTemp - detail.scannedBarcode.length)
            }else{
            detail.returnBarcode.forEach(returned => {
              const match = detail.scannedBarcode.some(scanned => scanned.itemUsed === returned.item);
              
              if (match) {
                ongoingReturnedQty++;
              } else {
                returnedQty++;
              }
            });
          }
        });
        return {
          ...order,
          ongoingReturnedQty,
          returnedQty
        };
      });
      return result;
    },
    deliveryOrders() {
      var tempDO = this.$store.getters["delivery/getDO"].filter(
        (x) => x.shippingPoint === "1003" || x.shippingPoint === "1203"
      );
      return tempDO;
    },
    permission() {
      let result = userAccess(
        "Return Delivery Sumitomo",
        "return_delivery_menu"
      );
      // console.log("Return Delivery Sumitomo",result)
      return result;
    },
  },
  created() {
    document.title = "Return Delivery | RSP";

    
  },
  mounted() {
    // this.$store.dispatch("delivery/getDeliveryOrder");
    //temporary for detail dropdown button conditional by mobile view or desktop view
    this.mobileViewQuery.addListener(() => {
      this.mobileView = this.mobileViewQuery.matches;
    });

    // Saving Menu Setting on localstorage session so it still same even after reloading the page
    if (this.$session.has("perPageReturnDelivery")) {
      this.perPage = this.$session.get("perPageReturnDelivery");
    }
    if (this.$session.has("sortByReturnDelivery")) {
      this.sortBy = this.$session.get("sortByReturnDelivery");
    }
    if (this.$session.has("sortDescReturnDelivery")) {
      this.sortDesc = this.$session.get("sortDescReturnDelivery");
    }
    var isMobile = window.matchMedia("(max-width: 761px)").matches;
    console.log("mobile is ", isMobile);
    var queryAvailable = -1;
    var query;
    if (this.$route.query.status) {
      query = this.$route.query.status;
      queryAvailable = this.listStatus.findIndex((x) => {
        return x == query;
      });
    }
    console.log("queryavailable ", queryAvailable);
    if (queryAvailable >= 0) {
      if (isMobile) {
        this.btnForMobile(query);
        return;
      }
      this.deliveryStatus = query;
    } else {
      this.deliveryStatus = "Returned";
    }
    if (this.$route.query.sapDo) {
      this.search = this.$route.query.sapDo;
      this.doFiltering()
    }
  },
  watch: {
    // Taking the Menu Setting from localstorage session so the setting will be the same as before
    perPage(perPageNew) {
      this.$session.set("perPageReturnDelivery", perPageNew);
    },
    sortBy(sortByNew) {
      this.$session.set("sortByReturnDelivery", sortByNew);
    },
    sortDesc(sortDescNew) {
      this.$session.set("sortDescReturnDelivery", sortDescNew);
    },
    // stackedStatus(stackedStatusNew) {
    //   this.$session.set("stackedStatusWarehouseDistribution", stackedStatusNew)
    // }
  },
  methods: {
    ...mapActions({
      getDeliveryOrder: "delivery/getDeliveryOrder",
      sendManualReturnToFTP: "delivery/sendManualReturnToFTP",
      sendReturnToFTP: "delivery/sendReturnToFTP"
    }),
    toFTP(data){
      
      this.ftpData.sapDo=data.sapDo,
      this.ftpData.id=data._id;
      this.ftpData.isManualReturn=data.manualReturnFlag>=1
      console.info('toFTP ',this.ftpData)
      this.modalFTP = true;
    },
    async sendFTP(){
      this.tableLoading=true;
      var ftpReturn;
      try {
        if(this.ftpData.isManualReturn){
          ftpReturn = await this.sendManualReturnToFTP(this.ftpData.id);
        }else{
          ftpReturn = await this.sendReturnToFTP(this.ftpData.id)
        }  
        if(ftpReturn.status==522){
          this.$bvToast.toast("Send Return PDF to FTP Failed", {
            title: "Failed",
            variant: "danger",
            solid: true,
          })
        }else{
          this.$bvToast.toast("Success to Request Return DO", {
            title: "Success",
            variant: "success",
            solid: true,
          });
        }
      } catch (err) {    
        this.$bvToast.toast("Send Return PDF to FTP Failed", {
          title: "Failed",
            variant: "danger",
            solid: true,
          })
      }
      
      this.queryDelivery()
      this.modalFTP = false;
      this.tableLoading=false;
    },
    onPageChange(page) {
      this.currentPage = page;
      this.queryDelivery();
    },
    processMetadata(metadata) {
      let { totalData } = metadata;
      this.totalRows = totalData;
      console.log("this.totalRows", this.totalRows);
      this.tableLoading = false;
    },
    //METHOD FOR MOBILE VIEW if needed same with other mobile view

    btnForMobile(filter) {
      this.deliveryStatus = filter;
      this.btnBackMobile = "hide-on-desktop";
      this.conditionView = "ml-md-auto show-on-desktop";
      this.btnshow = false;
      this.showDropdown = false;
      this.showSortBy = true;
    },
    actBackMobile() {
      this.btnBackMobile = "hide-at-all";
      this.conditionView = "ml-md-auto hide-on-mobile";
      this.btnshow = true;
      this.showDropdown = true;
      this.showSortBy = false;
    },
    //END METHOD FOR MOBILE VIEW
    dates(date) {
      return dateFormat(date);
    },
    queryDelivery() {
      let wantedStatus = [
        "Returned",
        "Waiting Acknowledgment",
        "Waiting Approval",
        "Approved",
        "Return Completed",
      ];
      this.getDeliveryOrder({
        shippingPoint:this.shippingPoint,
        page: this.currentPage,
        entry: this.perPage,
        sapDo: this.search,
        sapSo: this.searchSO,
        status:
          this.deliveryStatus == "All" ? wantedStatus : this.deliveryStatus,
        delivDate: this.delivDate,
      }).then((data) => {
        console.log("data", data);
        this.processMetadata(data.metadata);
      });
    },
    cleanQuery() {
      this.delivDate = "";
      // this.$store.dispatch("delivery/getDeliveryOrder");
      this.currentPage = 1;
      this.queryDelivery();
    },
    // doFiltering(value) {
    //   this.search = value;
    //   this.currentPage = 1;
    //   this.queryDelivery();
    // },
    doFiltering(){
      this.isLoading = true
      let wantedStatus = [
        "Returned",
        "Waiting Acknowledgment",
        "Waiting Approval",
        "Approved",
        "Return Completed",
      ];
      this.getDeliveryOrder({
        shippingPoint:this.shippingPoint,
        page: this.currentPage,
        entry: this.perPage,
        sapDo: this.search,
        sapSo: this.searchSO,
        status:
          this.deliveryStatus == "All" ? wantedStatus : this.deliveryStatus,
        delivDate: this.delivDate,
      }).then((data) => {
        this.isLoading = false
        this.processMetadata(data.metadata);
      }).catch((e) => {
        this.$bvToast.toast("Load data failed, please reload the page.", {
        title: "Warning",
        variant: "danger",
        solid: true,
        });
        console.log(e);
      });
    },
    fireFiltering(value) {
      this.delivDate = value;
      //this is for datepicker load store data with query
      // this.$store.dispatch("delivery/getDeliveryOrder", { delivDate: value });
      this.currentPage = 1;
      this.queryDelivery();
    },
    statusFiltering(value) {
      this.deliveryStatus = value;
      // console.log("this.deliveryStatus", this.deliveryStatus);
      // this.currentPage = 1;
      // this.queryDelivery();
    },
    toReturn(data) {
      let idDO = data._id;
      this.$router.push({
        name: "warehouse-return-delivery",
        params: { id: idDO, from: "return-sumitomo",status:this.deliveryStatus },
      });
    },
    toUnpickScan(data) {
      let idDO = data._id;
      this.$router.push({
        name: "warehouse-unpick-unscan",
        params: { id: idDO, from: "return-sumitomo",status:this.deliveryStatus },
      });
    },
    checkDetail(row) {
      var result;
      if (
        row.status != null &&
        row.status !== "" &&
        row.status !== "Delete Delivery" &&
        row.status !== "Delivery Canceled" &&
        row.status !== "Edit Delivery"
      ) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    toDetailPage(data) {
      let idDO = data._id;
      if (
        data.status === "Waiting Approval" ||
        data.status === "Waiting Acknowledgment"
      ) {
        this.$router.push({
          name: "warehouse-detail-for-completed",
          params: { id: idDO, from: "return-sumitomo",status:this.deliveryStatus },
        });
      } else {
        this.$router.push({
          name: "warehouse-detail-delivery",
          params: { id: idDO, from: "return-sumitomo",status:this.deliveryStatus },
        });
      }
    },
  },
};
</script>
<style scope>
.hide-at-all {
  display: none !important;
}

/* For mobile phones: */
@media (max-width: 761px) {
  .hide-on-mobile {
    display: none !important;
  }
}

/* For computer: */
@media (min-width: 761px) {
  .hide-on-desktop {
    display: none !important;
  }
  .show-on-desktop {
    display: inline !important;
  }
}

.custom-row-height {
  min-height: 120px; /* Adjust this value as needed */
}

</style>
